import ROR_LOGO from '../assets/Images/twiggy-logo.jpeg';
import AddToMobileButton from '../components/auth/AddToMobileButton';
import GoogleLoginButton from '../components/auth/GoogleLoginButton';

export default function Home() {
  return (
    <div className="flex flex-col items-center justify-center h-screen text-center">
      <img src={ROR_LOGO} alt="Twiggy" className="absolute w-36 top-8 left-8" />
      <h1 className="mb-2 text-2xl">Welcome to</h1>
      <h2 className="text-3xl text-red-600 mb-2">Twiggy by Red Oak Realty</h2>

      <GoogleLoginButton />
      <h4 className="mt-3 text-1xl text-gray-500">
        Please sign in using your Red Oak account.
      </h4>
      <AddToMobileButton />
    </div>
  );
}
